module.exports = __webpack_public_path__ + "static/media/history.4c26906e.svg";